require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-c-3-f-76-nc-3-oamv-z-4-mc-8-pn-lmm-1.json") })
        }
      }, "path---news-c-3-f-76-nc-3-oamv-z-4-mc-8-pn-lmm-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-c-3-f-76-nc-3-oamv-z-4-mc-8-pn-lmm-1!./.cache/json/news-c-3-f-76-nc-3-oamv-z-4-mc-8-pn-lmm-1.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-c-3-f-76-nc-3-oamv-z-4-mc-8-pn-lmm-1!./.cache/json/news-c-3-f-76-nc-3-oamv-z-4-mc-8-pn-lmm-1.json
// module chunks = 231608221292675